import {  Component ,  Input ,  OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MultipleLoadingViewModel } from '../../../models/multipleLoadingView.model';

@Component({
  selector: 'app-multiple-loading-view',
  templateUrl: './multiple-loading-view.component.html',
  styleUrls: ['./multiple-loading-view.component.css']
})
export class MultipleLoadingViewComponent implements OnInit {


  @Input() public callList:MultipleLoadingViewModel[] = [];
  
  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.callList.forEach((item, i,) => {
      item.call().subscribe(
        (response) => {
          item.loading = false;
          item.resultSuccess = true;
        },
        (error) => {
          item.loading = false;
          item.resultSuccess = false;
        });
    });
  }

}
